import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketListComponent } from './ticket-list/ticket-list.component';
import { TicketTransferStatusComponent } from './ticket-transfer-status/ticket-transfer-status.component';
import { TicketTransferSelectBar } from './ticket-transfer-select-bar/ticket-transfer-select-bar.component';
import { RecipientFormComponent } from '@fgb/portal-component-library/src/lib/shared/forms/recipient-form';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { TicketTransferLogComponent } from './ticket-list-item/ticket-transfer-log/ticket-transfer-log.component';
import { SelectedTicketsTableModule } from './selected-tickets-table/selected-tickets-table.module';
import { TicketListItemComponent } from './ticket-list-item/ticket-list-item.component';
import { TicketTransferGamePanelModule } from './ticket-transfer-game-panel/ticket-transfer-game-panel.module';
import { GamesListWithTicketsModule } from './games-list-with-tickets/games-list-with-tickets.module';
import { TicketInviteModule } from './ticket-invite/ticket-invite.module';
import { TicketTransferWindowStatusModule } from './ticket-transfer-window-status/ticket-transfer-window-status.module';
import { ContactsManagementModule } from './contacts-management/contacts-management.module';
import { GamesWithTicketsListComponent } from './games-with-tickets-list/games-with-tickets-list.component';
import { TicketSelectionListComponent } from './ticket-selection-list/ticket-selection-list.component';
import { DataSourceDirective, DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

@NgModule({
  declarations: [
    TicketListComponent,
    TicketListItemComponent,
    TicketTransferLogComponent,
    GamesWithTicketsListComponent,
    TicketSelectionListComponent
  ],
  imports: [
    CommonModule,
    FGBSharedModule,
    SelectedTicketsTableModule,
    TicketTransferStatusComponent,
    TicketTransferSelectBar,
    RecipientFormComponent,
    TicketTransferGamePanelModule,
    GamesListWithTicketsModule,
    TicketInviteModule,
    TicketTransferWindowStatusModule,
    ContactsManagementModule,
    ErrorsModule,
    LoadingModule,
    DataSourceDirective,
    DirectivesModule
  ],
  exports: [
    TicketListComponent, 
    TicketListItemComponent, 
    TicketTransferStatusComponent,
    TicketSelectionListComponent, 
    TicketTransferSelectBar, 
    RecipientFormComponent, 
    TicketTransferLogComponent, 
    SelectedTicketsTableModule, 
    TicketTransferGamePanelModule, 
    GamesListWithTicketsModule,
    TicketInviteModule,
    TicketTransferWindowStatusModule,
    ContactsManagementModule,
    GamesWithTicketsListComponent
  ]
})
export class TicketTransferModule { }
